<template>
  <LayoutGradient :title="pageTitle" icon="fa-file-signature">
    <template v-slot:headerRight>
      <b-btn variant="outline-info" @click="$router.back()">
        <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
      </b-btn>
    </template>
    <b-overlay :show="isLoading" class="m-3 mt-n10" no-center>
      <template v-slot:overlay>
        <div class="d-flex mt-5">
          <div class="m-auto">
            <b-icon icon="stopwatch" font-scale="3" animation="cylon"/>
            <p>Carregando...</p>
          </div>
        </div>
      </template>
      <b-card class="m-3 mt-n10">
        <b-form @submit="onSubmit">
          <b-form-group
              label-cols-lg="2" :label="$t('vns.form.fieldsets.informacoes')"
              label-size="lg" label-class="font-weight-bold pt-0"
              class="border-bottom-info mb-5"
          >
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.nome.description')"
                :label="$t('vns.form.fields.nome.label')"
                label-for="input-name"
                class="col"
            >
            <b-form-input id="input-name" v-model="vns.name"/>
            </b-form-group>
           
           <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.empresa.description')"
                :label="$t('vns.form.fields.empresa.label')"
                label-for="input-companies"
                class="col"
            >
              <b-overlay :show="companiesLoading">
                <v-select
                    id="input-companies"
                    class="w-100"
                    :value="vns.company_id"
                    @input="c => setVnsAndCoreUnitCompany('company_id', c)"
                    @search="evt => $store.dispatch('corecompanies/search', {filters: [['name', 'LIKE', `%${evt}%`]]})"
                    :options="companies"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.unidade.description')"
                :label="$t('vns.form.fields.unidade.label')"
                label-for="input-unidades"
                class="col"
            >
              <b-overlay :show="unitLoading">
                <v-select
                    id="input-unidades"
                    :disabled="!vns.company_id"
                    class="w-100"
                    :value="vns.core_care_units_id"
                    @input="c => setVnsAndCoreSector('core_care_units_id', c)"
                    @search="evt => $store.dispatch('corecareunits/search', {filters: [['name', 'LIKE', `%${evt}%`]]})"
                    :options="careunit"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.setor.description')"
                :label="$t('vns.form.fields.setor.label')"
                label-for="input-setores"
                class="col"
            >
              <b-overlay :show="sectorLoading">
                <v-select
                    id="input-setores"
                    :disabled="!vns.core_care_units_id"
                    class="w-100"
                    :value="vns.core_sector_id"
                    @input="c => setVns('core_sector_id', c)"
                    @search="evt => $store.dispatch('coresectors/search', {filters: [['name', 'LIKE', `%${evt}%`]]})"
                    :options="sector"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.estado.description')"
                :label="$t('vns.form.fields.estado.label')"
                label-for="input-states"
                class="col"
            >
              <b-overlay :show="statesLoading">
                <v-select
                    id="input-states"
                    class="w-100"
                    :value="vns.vns_state_id"
                    @input="s => setVns('vns_state_id', s)"
                    :options="states"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
          </b-form-group>

          <b-form-group
              label-cols-lg="2"
              :label="$t('vns.form.fieldsets.integracoes')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="border-bottom-info mb-5"
          >
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.integracao_origem.description')"
                :label="$t('vns.form.fields.integracao_origem.label')"
                label-for="input-integracao_origem"
                class="col"
            >
              <b-overlay :show="integrationsLoading">
                <v-select
                    id="input-integracao_origem"
                    class="w-100"
                    :value="vns.vns_integration_origin_id"
                    @input="i => setVns('vns_integration_origin_id', i)"
                    :options="integrations"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.credencial_origem.description')"
                :label="$t('vns.form.fields.credencial_origem.label')"
                label-for="input-credencial_origem"
                class="col"
            >
              <b-overlay :show="credentialsLoading">
                <v-select
                    id="input-credencial_origem"
                    class="w-100"
                    :value="vns.vns_credential_origin_id"
                    @input="c => setVns('vns_credential_origin_id', c)"
                    :options="credentials"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.integracao_destino.description')"
                :label="$t('vns.form.fields.integracao_destino.label')"
                label-for="input-integracao_destino"
                class="col"
            >
              <b-overlay :show="integrationsLoading">
                <v-select
                    id="input-integracao_destino"
                    class="w-100"
                    :value="vns.vns_integration_destination_id"
                    @input="i => setVns('vns_integration_destination_id', i)"
                    :options="integrations"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.credencial_destino.description')"
                :label="$t('vns.form.fields.credencial_destino.label')"
                label-for="input-credencial_destino"
                class="col"
            >
              <b-overlay :show="credentialsLoading">
                <v-select
                    id="input-credencial_destino"
                    class="w-100"
                    :value="vns.vns_credential_destination_id"
                    @input="c => setVns('vns_credential_destination_id', c)"
                    :options="credentials"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.integracao_impressao.description')"
                :label="$t('vns.form.fields.integracao_impressao.label')"
                label-for="input-integracao_impressao"
                class="col"
            >
              <b-overlay :show="integrationsLoading">
                <v-select
                    id="input-integracao_impressao"
                    class="w-100"
                    :value="vns.vns_integration_printer_id"
                    @input="i => setVns('vns_integration_printer_id', i)"
                    :options="integrations"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.credencial_impressao.description')"
                :label="$t('vns.form.fields.credencial_impressao.label')"
                label-for="input-credencial_impressao"
                class="col"
            >
              <b-overlay :show="credentialsLoading">
                <v-select
                    id="input-credencial_impressao"
                    class="w-100"
                    :value="vns.vns_credential_printer_id"
                    @input="c => setVns('vns_credential_printer_id', c)"
                    :options="credentials"
                    :reduce="option => option.id"
                    label="name"
                />
              </b-overlay>
            </b-form-group>
            <b-form-group
                label-cols-sm="4"
                label-cols-lg="3"
                :description="$t('vns.form.fields.atributos.description')"
                :label="$t('vns.form.fields.atributos.label')"
                label-for="input-atributos"
                class="col"
            >
              <b-overlay :show="attributesLoading">
                <b-form-select id="input-atributos"
                               :value="vns.vns_attributes_ids"
                               :options="attributes"
                               options-field="id"
                               label-field="name"
                               multiple/>
              </b-overlay>
            </b-form-group>
          </b-form-group>

          <b-form-group
              label-cols-lg="2"
              :label="$t('vns.form.fieldsets.perifericos')"
              label-size="lg"
              label-class="font-weight-bold pt-0"
              class="border-bottom-info mb-5"
          >
            <b-form-group
                :label="$t('vns.form.fields.modem.label')"
                label-for="input-modem"
            >
              <b-form-checkbox
                  id="input-modem"
                  v-model="vns.modem_enabled"
                  @change="(v) => setVns('modem_enabled', v)"
                  size="lg"
                  switch
              />
              <div v-if="vns.modem_enabled" class="row mt-3">
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.serial.description')"
                      :label="$t('vns.form.fields.modem.serial.label')"
                      label-for="input-modem_serial"
                      class="col"
                  >
                    <b-form-input id="input-modem_serial" v-model="vns.modem_serial"/>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.numero_chip.description')"
                      :label="$t('vns.form.fields.modem.numero_chip.label')"
                      label-for="input-modem_chip_number"
                      class="col"
                  >
                    <b-form-input id="input-modem_chip_number" v-model="vns.modem_chip_number"/>
                  </b-form-group>
                </div>
              </div>
              <div v-if="vns.modem_enabled" class="row">
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.empresa.description')"
                      :label="$t('vns.form.fields.modem.empresa.label')"
                      label-for="input-modem_company"
                      class="col"
                  >
                    <b-form-input id="input-modem_company" v-model="vns.modem_company"/>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.data_limit.description')"
                      :label="$t('vns.form.fields.modem.data_limit.label')"
                      label-for="input-modem_data_limit"
                      class="col"
                  >
                    <b-form-input id="input-modem_data_limit" v-model="vns.modem_data_limit"/>
                  </b-form-group>
                </div>
              </div>
              <div v-if="vns.modem_enabled" class="row">
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.data_alert.description')"
                      :label="$t('vns.form.fields.modem.data_alert.label')"
                      label-for="input-modem_data_alert"
                      class="col"
                  >
                    <b-form-input id="input-modem_data_alert" v-model="vns.modem_data_alert"/>
                  </b-form-group>
                </div>
                <div class="col-md-6">
                  <b-form-group
                      :description="$t('vns.form.fields.modem.data_consumption.description')"
                      :label="$t('vns.form.fields.modem.data_consumption.label')"
                      label-for="input-modem_data_consumption"
                      class="col"
                  >
                    <b-form-input id="input-modem_data_consumption"
                                  v-model="vns.modem_data_consumption"/>
                  </b-form-group>
                </div>
              </div>
            </b-form-group>
            <b-form-group :label="$t('vns.form.fields.gps.label')" label-for="input-gps" class="mt-5">
              <b-form-checkbox
                  id="input-gps"
                  v-model="vns.gps_enabled"
                  @change="(v) => setVns('gps_enabled', v)"
                  size="lg"
                  switch
              />
              <b-form-group
                  v-if="vns.gps_enabled"
                  :description="$t('vns.form.fields.gps.numero.description')"
                  :label="$t('vns.form.fields.gps.numero.label')"
                  label-for="input-gps_number"
                  class="col"
              >
                <b-form-input id="input-gps_number" v-model="vns.gps_number"/>
              </b-form-group>
            </b-form-group>
            <b-form-group
                :label="$t('vns.form.fields.sensor_temperatura.label')"
                :description="$t('vns.form.fields.sensor_temperatura.description')"
                label-for="input-sensor_temperatura"
            >
              <b-form-checkbox
                  id="input-sensor_temperatura"
                  v-model="vns.temperature_sensor_enabled"
                  @change="(v) => setVns('temperature_sensor_enabled', v)"
                  size="lg"
                  switch
              />
            </b-form-group>
          </b-form-group>

          <b-form-group
              :label="$t('vns.form.fields.status.label')"
              :description="$t('vns.form.fields.status.description')"
              label-for="input-status"
          >
            <b-form-checkbox
                id="input-status"
                v-model="vns.status"
                @change="(v) => setVns('status', v)"
                size="lg"
                switch
            />
          </b-form-group>

          <b-form-group
              :label="$t('vns.form.fields.monitor.label')"
              :description="$t('vns.form.fields.monitor.description')"
              label-for="input-monitor"
          >
            <b-form-checkbox
                id="input-monitor"
                v-model="vns.monitor"
                @change="(v) => setVns('monitor', v)"
                size="lg"
                switch
            />
          </b-form-group>

          <b-button type="submit" variant="success">
            <i class="fas fa-save"/> {{ $t('vns.form.fields.botao_salvar') }}
          </b-button>
        </b-form>
      </b-card>
    </b-overlay>
  </LayoutGradient>
</template>

<script>
import LayoutGradient from "@/templates/LayoutGradient"
import VnsRepository from '@/repositories/vns/VnsRepository'
import vSelect from 'vue-select'
import {mapActions, mapGetters} from "vuex"

export default {
  name: "Form",
  components: {
    LayoutGradient,
    vSelect
  },
  computed: {
    ...mapGetters({
      vns: 'vns/current',
      store_isLoading: 'vns/isLoading',
      companies: 'corecompanies/all',
      companiesLoading: 'corecompanies/isLoading',
      credentials: 'credential/all',
      credentialsLoading: 'credential/isLoading',
      integrations: 'integration/all',
      integrationsLoading: 'integration/isLoading',
      attributes: 'attribute/all',
      attributesLoading: 'attribute/isLoading',
      states: 'states/all',
      statesLoading: 'states/isLoading',
      careunit: 'corecareunits/all',
      unitLoading: 'corecareunits/isLoading',
      sector: 'coresectors/all',
      sectorLoading: 'coresectors/isLoading'
    }),
    isLoading() {
      return !(this.mounted && this.store_isLoading === false)
    },
    pageTitle() {
      if (this.vns_id) return this.$t('vns.form.titulo_pagina.editar')
      return this.$t('vns.form.titulo_pagina.criar')
    },
  },
  data() {
    return {
      vns_id: null,
      mounted: false
    }
  },
  methods: {
    ...mapActions([
      'vns/listOne',
      'corecompanies/listAll',
      'corecompanies/search',
      'states/search',
      'integration/search',
      'credential/search',
      'attribute/search',
      'corecareunits/search',
      'coresectors/search',
    ]),
    setVns(key, value) {
      this.$store.commit('vns/setCurrent', {...this.vns, [key]: value})
    },
    setVnsAndCoreUnitCompany(key, value) {
      this.$store.commit('vns/setCurrent', {...this.vns, [key]: value})
      this.$store.commit('vns/setCurrent', {...this.vns, ['core_care_units_id']: null})
      this.$store.commit('vns/setCurrent', {...this.vns, ['core_sector_id']: null})
      this.$store.dispatch('corecareunits/search', {filters: [['core_company_id', '=', `${value}`]]})
    },
    setVnsAndCoreSector(key, value) {
      this.$store.commit('vns/setCurrent', {...this.vns, [key]: value})
      this.$store.commit('vns/setCurrent', {...this.vns, ['core_sector_id']: null})
      this.$store.dispatch('coresectors/search', {filters: [['core_care_unit_id', '=', `${value}`]]})
    },    
    async onSubmit(evt) {
      evt.preventDefault()
      if (this.$route.params.id) {
        this.update()
      } else {
        this.create()
      }
    },
    create() {
      VnsRepository.post(this.vns).then(() => {
        this.$snotify.success(this.$t('vns.form.create.success'))
        this.$router.push({name: 'vns.index'})
      }).catch(error => {
        this.$snotify.error(this.$t('vns.form.create.error'))
        if (error.response.status === 422) {
          VnsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      VnsRepository.put(this.vns_id, this.vns).then(() => {
        this.$snotify.success(this.$t('vns.form.update.success'))
        this.$router.push({name: 'vns.index'})
      }).catch(error => {
        this.$snotify.error(this.$t('vns.form.update.error'))
        if (error.response.status === 422) {
          VnsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('vns/setCurrent', {})
    this['corecompanies/listAll']()
    this['corecareunits/search']()
    this['coresectors/search']()
    this['states/search']()
    this['integration/search']()
    this['credential/search']()
    this['attribute/search']()

    this.setVns('modem_enabled', false)
    this.setVns('gps_enabled', false)
    this.setVns('temperature_sensor_enabled', false)
    this.setVns('status', false)
    this.setVns('monitor', false)

    if (this.$route.params.id) {
      this.vns_id = this.$route.params.id
      await this['vns/listOne'](this.$route.params.id)
      this.setVns('modem_enabled', !!this.vns.modem_enabled)
      this.setVns('gps_enabled', !!this.vns.gps_enabled)
      this.setVns('temperature_sensor_enabled', !!this.vns.temperature_sensor_enabled)
      this.setVns('status', !!this.vns.status)
      this.setVns('monitor', !!this.vns.monitor)

      if (this.companies.filter(c => this.vns.company_id === c.id).length === 0) {
        this['corecompanies/search']({filters: [['id', '=', this.vns.company_id]]})
      }

      if (this.careunit.filter(c => this.vns.core_care_units_id === c.id)) {
        this['corecareunits/search']({filters: [['core_company_id', '=', this.vns.company_id]]})        
      }

      if (this.sector.filter(c => this.vns.core_sector_id === c.id)) {
        this['coresectors/search']({filters: [['core_care_unit_id', '=', this.vns.core_care_units_id]]})        
      }

    }
    this.setVns('vns_attributes_ids', this.vns.vns_attributes_ids || [])
    this.mounted = true
  }
}
</script>

<style lang="scss" scoped>
</style>
